"use client";

import { useCallback } from "react";
import { MagnifyingGlass } from "@phosphor-icons/react";
import type { SharedProps } from "fumadocs-ui/components/dialog/search";
import SearchDialog from "fumadocs-ui/components/dialog/search-default";

import { Input } from "@shared/ui/input";

export const SearchInput = () => {
  const triggerSearch = useCallback(() => {
    // simulating pressing Ctrl+K/Cmd+K programmatically
    const event = new KeyboardEvent("keydown", {
      key: "k",
      code: "KeyK",
      metaKey: true, // mac
      ctrlKey: true, // windows/linux
      bubbles: true,
    });
    document.dispatchEvent(event);
  }, []);

  return (
    <div className="relative xl:px-0">
      <MagnifyingGlass className="absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2 text-[var(--docs-link-rest)]" />
      <Input
        className="docs-input w-full pl-8 xl:w-[300px]"
        placeholder="Search Documentation"
        onClick={(e) => {
          e.preventDefault();
          triggerSearch();
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            triggerSearch();
          }
        }}
        readOnly
      />
      <span className="absolute top-1/2 right-3 hidden -translate-y-1/2 rounded border border-white/20 px-1.5 py-0.5 text-xs text-[var(--docs-link-rest)] xl:block">
        ⌘K
      </span>
    </div>
  );
};

export default function FumaSearch(props: SharedProps) {
  return (
    <div className="relative z-[999]">
      <SearchDialog {...props} />
    </div>
  );
}
